import React, { useState } from 'react';

const RefundPolicy = () => {
  const [expandedSection, setExpandedSection] = useState('');
  
  const toggleSection = (section) => {
    if (expandedSection === section) {
      setExpandedSection('');
    } else {
      setExpandedSection(section);
    }
  };
  
  return (
    <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg overflow-hidden">
      {/* Header */}
      <div className="bg-blue-700 p-6 text-white">
        <h1 className="text-2xl font-bold">IndiaHirings.com 100% Refund Policy</h1>
        <p className="mt-2">
          We are committed to delivering the best value and results for your recruitment needs.
          Our 100% Money-Back Guarantee ensures a hassle-free refund if we fail to meet the agreed criteria.
        </p>
      </div>
      
      {/* Main Content */}
      <div className="p-6">
        {/* Eligibility Section */}
        <div className="mb-6">
          <div 
            className="flex justify-between items-center cursor-pointer bg-gray-50 p-4 rounded-md hover:bg-gray-100"
            onClick={() => toggleSection('eligibility')}
          >
            <h2 className="text-xl font-semibold text-blue-700">Eligibility for 100% Refund</h2>
            <span className="text-blue-700 text-2xl">{expandedSection === 'eligibility' ? '−' : '+'}</span>
          </div>
          
          {expandedSection === 'eligibility' && (
            <div className="mt-3 p-4 bg-gray-50 rounded-md">
              <p className="mb-2">You are eligible for a full refund if the following conditions are not met:</p>
              
              <div className="ml-4 space-y-4 mt-4">
                <div>
                  <h3 className="font-medium text-blue-700">Job Post Visibility:</h3>
                  <p className="ml-4">Your job posting is not visible on the IndiaHirings platform within 24 hours of activation.</p>
                </div>
                
                <div>
                  <h3 className="font-medium text-blue-700">Response Guarantee:</h3>
                  <p className="ml-4">You do not receive at least 50% of the promised responses/applications within the plan duration.</p>
                  <p className="ml-4 text-sm italic">Example: If your plan guarantees 100 responses, you must receive a minimum of 50 responses.</p>
                </div>
                
                <div>
                  <h3 className="font-medium text-blue-700">Relevant Applications:</h3>
                  <p className="ml-4">You do not receive a minimum of 10 relevant candidate applications for your active job post within the first 7 days.</p>
                </div>
                
                <div>
                  <h3 className="font-medium text-blue-700">Candidate Engagement:</h3>
                  <p className="ml-4">Candidates do not respond to at least 20% of your outreach (calls, emails, or database access), as per plan features.</p>
                </div>
                
                <div>
                  <h3 className="font-medium text-blue-700">Plan Activation Issues:</h3>
                  <p className="ml-4">If there are technical issues from our side that prevent you from utilizing the plan benefits (e.g., inability to access the database or post jobs).</p>
                </div>
                
                <div>
                  <h3 className="font-medium text-blue-700">Adherence to Guidelines:</h3>
                  <p className="ml-4">Your job postings and employer profile meet the platform's terms of service and KYC verification requirements.</p>
                </div>
              </div>
            </div>
          )}
        </div>
        
        {/* How to Request Section */}
        <div className="mb-6">
          <div 
            className="flex justify-between items-center cursor-pointer bg-gray-50 p-4 rounded-md hover:bg-gray-100"
            onClick={() => toggleSection('request')}
          >
            <h2 className="text-xl font-semibold text-blue-700">How to Request a Refund?</h2>
            <span className="text-blue-700 text-2xl">{expandedSection === 'request' ? '−' : '+'}</span>
          </div>
          
          {expandedSection === 'request' && (
            <div className="mt-3 p-4 bg-gray-50 rounded-md">
              <p className="mb-2">If you believe the above criteria were not fulfilled, you can initiate a refund request through the following methods:</p>
              
              <div className="ml-4 space-y-4 mt-4">
                <div>
                  <h3 className="font-medium text-blue-700">Employer Dashboard:</h3>
                  <p className="ml-4">Go to your dashboard, click on "Request Refund", and provide details about the issue.</p>
                </div>
                
                <div>
                  <h3 className="font-medium text-blue-700">Email Support:</h3>
                  <p className="ml-4">Send an email to <a href="mailto:refunds@indiahirings.com" className="text-blue-600 hover:underline">refunds@indiahirings.com</a> with the subject line: "Refund Request - [Your Plan Name]".</p>
                </div>
                
                <div>
                  <h3 className="font-medium text-blue-700">Customer Support:</h3>
                  <p className="ml-4">Call our support team at xxxxxxxx (Mon-Sat: 10 AM - 6 PM).</p>
                </div>
                
                <div>
                  <h3 className="font-medium text-blue-700">Live Chat Support:</h3>
                  <p className="ml-4">Use the Live Chat feature on our website or app to raise your refund request.</p>
                </div>
              </div>
            </div>
          )}
        </div>
        
        {/* Timeline Section */}
        <div className="mb-6">
          <div 
            className="flex justify-between items-center cursor-pointer bg-gray-50 p-4 rounded-md hover:bg-gray-100"
            onClick={() => toggleSection('timeline')}
          >
            <h2 className="text-xl font-semibold text-blue-700">Refund Process Timeline</h2>
            <span className="text-blue-700 text-2xl">{expandedSection === 'timeline' ? '−' : '+'}</span>
          </div>
          
          {expandedSection === 'timeline' && (
            <div className="mt-3 p-4 bg-gray-50 rounded-md">
              <div className="ml-4 space-y-4">
                <div>
                  <h3 className="font-medium text-blue-700">Initial Review:</h3>
                  <p className="ml-4">Our team will validate your refund request within 48 to 72 hours of submission.</p>
                </div>
                
                <div>
                  <h3 className="font-medium text-blue-700">Approval & Processing:</h3>
                  <p className="ml-4">Once approved, the refund will be processed within 10 to 15 business days.</p>
                  <p className="ml-4">The amount will be credited back to your original payment method.</p>
                </div>
              </div>
            </div>
          )}
        </div>
        
        {/* Terms Section */}
        <div className="mb-6">
          <div 
            className="flex justify-between items-center cursor-pointer bg-gray-50 p-4 rounded-md hover:bg-gray-100"
            onClick={() => toggleSection('terms')}
          >
            <h2 className="text-xl font-semibold text-blue-700">Refund Terms & Conditions</h2>
            <span className="text-blue-700 text-2xl">{expandedSection === 'terms' ? '−' : '+'}</span>
          </div>
          
          {expandedSection === 'terms' && (
            <div className="mt-3 p-4 bg-gray-50 rounded-md">
              <p className="mb-2">Refund requests must be submitted within 15 days of plan activation.</p>
              <p className="mb-2">Refunds will not be issued if:</p>
              
              <ul className="list-disc ml-8 mb-4">
                <li>The promised responses or applications have been delivered.</li>
                <li>Platform policies have been violated (e.g., fake job posts, misleading information, or blacklisted job types).</li>
                <li>The usage exceeds 25% of the plan benefits (e.g., database views, candidate calls, or job responses).</li>
              </ul>
              
              <p>Refunds are allowed only once per plan.</p>
            </div>
          )}
        </div>
        
        {/* Blacklisting Section */}
        <div className="mb-6">
          <div 
            className="flex justify-between items-center cursor-pointer bg-gray-50 p-4 rounded-md hover:bg-gray-100"
            onClick={() => toggleSection('blacklisting')}
          >
            <h2 className="text-xl font-semibold text-blue-700">IndiaHirings.com Blacklisting Policy</h2>
            <span className="text-blue-700 text-2xl">{expandedSection === 'blacklisting' ? '−' : '+'}</span>
          </div>
          
          {expandedSection === 'blacklisting' && (
            <div className="mt-3 p-4 bg-gray-50 rounded-md">
              <p className="mb-2">Employers engaging in the following activities will be blacklisted and ineligible for refunds:</p>
              
              <div className="ml-4 space-y-2 mt-2">
                <div>
                  <h3 className="font-medium text-blue-700">Fake or Misleading Job Posts:</h3>
                  <p className="ml-4">Posting incorrect job details or clickbait jobs.</p>
                </div>
                
                <div>
                  <h3 className="font-medium text-blue-700">Charging Candidates:</h3>
                  <p className="ml-4">Collecting fees like registration, placement, or exam fees.</p>
                </div>
                
                <div>
                  <h3 className="font-medium text-blue-700">Policy Violations:</h3>
                  <p className="ml-4">Jobs involving inappropriate content, MLM schemes, personal favors, or fraudulent activities.</p>
                </div>
                
                <div>
                  <h3 className="font-medium text-blue-700">Misinformation:</h3>
                  <p className="ml-4">Spreading false job details or misusing candidate information.</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      
      {/* Footer */}
      <div className="bg-gray-100 p-6 border-t">
        <h2 className="text-xl font-semibold text-blue-700 mb-3">Why IndiaHirings.com?</h2>
        <p className="mb-4">
          We stand by our promise of quality and transparency. If we don't deliver as committed, 
          we guarantee a 100% refund to ensure your satisfaction and trust.
        </p>
        <div className="bg-blue-50 p-4 rounded-lg border border-blue-200 text-center">
          <p className="mb-2">For any issues, contact us at <a href="mailto:refunds@indiahirings.com" className="text-blue-600 hover:underline">refunds@indiahirings.com</a> or call xxxxxx</p>
          <p className="font-semibold text-blue-700">Your success is our priority!</p>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;